export const expert = {
  is_programme_expert: false,
  programs: [],
  first_name: "",
  full_name: "",
  is_hidden: false,
  spotlight: false,
  allow_app_registration: true,
  meet_link: "",
  session_head_start_count: "",
  age: "",
  about: "",
  date_of_birth: "",
  holds_professional_license: false,
  professional_license_details: "",
  outside_work: "",
  profession: "",
  top_expertise: [],
  all_expertise: [],
  profile_gender: "",
  highest_education: "",
  professional_certifications: [],
  practicing_experience_years: "",
  languages_known: [],
  profile_introduction: "",
  why_therapist: "",
  therapy_approach: "",
  phone_number: "",
  whatsapp_phone_number: "",

  country_code:"",
  personal_email_id: "",
  manoshala_email_id: "",
  address: "",
  longitude: "",
  latitude: "",
  specialization: "",
  description: "",
  service_page_link: "",
  total_experience: "",
  experience_points: [],
  education: [],
  area_of_expertise: [],
  lead_symptoms: [],
  lead_budget_range: "",
  lead_gender: [],
  lead_age_range: "",
  lead_language: [],
  city: "",
  state: "",
  country: "",
  pin_code: "",
  manoshala_id: "",
  session_duration: "",
  default_session_price: "",
  discounted_price: "",
  session_price: {
    in_person: "",
    chat: "",
    call: "",
    video: "",
  },
  duration: {
    in_person: "",
    chat: "",
    call: "",
    video: "",
  },
  audience_session_config: {
    personal: {
      session_price: { in_person: "", call: "", video: "", chat: "" },
      duration: { in_person: "45", call: "45", video: "45", chat: "30" },
      subscription_price: {
        in_person: { three_session: "", five_session: "", ten_session: "" },
        video: { three_session: "", five_session: "", ten_session: "" },
        call: { three_session: "", five_session: "", ten_session: "" },
        chat: { three_session: "", five_session: "", ten_session: "" },
      },
    },
    couple: {
      session_price: { in_person: "", call: "", video: "", chat: "" },
      duration: { in_person: "90", call: "90", video: "90", chat: "90" },
      subscription_price: {
        in_person: { three_session: "", five_session: "", ten_session: "" },
        video: { three_session: "", five_session: "", ten_session: "" },
        call: { three_session: "", five_session: "", ten_session: "" },
        chat: { three_session: "", five_session: "", ten_session: "" },
      },
    },
    family: {
      session_price: { in_person: "", call: "", video: "", chat: "" },
      duration: { in_person: "90", call: "90", video: "90", chat: "90" },
      subscription_price: {
        in_person: { three_session: "", five_session: "", ten_session: "" },
        video: { three_session: "", five_session: "", ten_session: "" },
        call: { three_session: "", five_session: "", ten_session: "" },
        chat: { three_session: "", five_session: "", ten_session: "" },
      },
    },
  },
  bank_details: {
    account_holder_name: "",
    account_number: "",
    bank_name: "",
    ifsc_code: "",
  },
  manthan: {
    is_supervision_active: false,
    supervision_batch_id: "",
    supervision_enrollment_no: "",
  },
  is_in_person_enabled: true,
  is_call_enabled: true,
  is_video_enabled: true,
  is_chat_enabled: false,
  three_session: "",
  ten_session: "",
  five_session: "",
  chat_three_session: "",
  chat_five_session: "",
  chat_ten_session: "",
  in_person_three_session: "",
  in_person_five_session: "",
  in_person_ten_session: "",
  call_three_session: "",
  call_five_session: "",
  call_ten_session: "",
  session_delivery_mode: [],
  tags: [],
  onboarding_documents_folder_link: "",
  contract_documents_folder_link: "",
  photograph_link: "",
  lead_severity: [],
  role: "",
  type: [],
  rating: "",
  title: "",
  details: "",
  voice_note_link: "",
  style: [],
  certifications: [],
  feedback: [],
  no_of_patients: "",
  gender: "",
  approach_to_therapy: "",
  first_session: "",
  leaves: [],
  messages: [],
  fcm_token: "",
  rejected_bookings: [],
  prices: [],
  is_archived: false,
  google_info: {
    calendar: {
      access_token: "",
      refresh_token: "",
    },
    name: "",
    email: "",
    picture: "",
  },
};
export function convertDateStringsToDateObjects(event: any) {
  const start = new Date(event.start);
  const end = new Date(event.end);

  const convertedEvent = {
    start,
    end,
  };

  return convertedEvent;
}
export function generateEventsForCurrentWeek(schedule: { [x: string]: any }) {
  const daysOfWeek = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const currentDay = currentDate.getDate();

  const events = [];
  for (let i = 0; i < 7; i++) {
    const eventDate = new Date(currentYear, currentMonth, currentDay + i);
    const dayIndex = eventDate.getDay();
    const day = daysOfWeek[dayIndex];
    const daySchedule = schedule[day];

    if (daySchedule && daySchedule.length > 0) {
      for (const event of daySchedule) {
        const startHour = parseInt(event.start.split(":")[0], 10);
        const startMinute = parseInt(event.start.split(":")[1], 10);
        const endHour = parseInt(event.end.split(":")[0], 10);
        const endMinute = parseInt(event.end.split(":")[1], 10);

        const newEvent = {
          start: new Date(
            eventDate.getFullYear(),
            eventDate.getMonth(),
            eventDate.getDate(),
            startHour,
            startMinute,
            0
          ),
          end: new Date(
            eventDate.getFullYear(),
            eventDate.getMonth(),
            eventDate.getDate(),
            endHour,
            endMinute,
            0
          ),
        };

        events.push(newEvent);
      }
    }
  }

  return events;
}

export const DEFAULT_AUDIENCE_DURATIONS: Record<string, string> = {
  personal: "45",
  couple: "90",
  family: "90",
};

export const AUDIENCE_TYPE_OPTIONS = [
  { value: "personal", label: "Personal (Individual)" },
  { value: "couple", label: "Couple" },
  { value: "family", label: "Family" },
];

export const DELIVERY_MODE_OPTIONS = [
  { value: "in_person", label: "In-person" },
  { value: "video", label: "Video" },
  { value: "call", label: "Call" },
  { value: "chat", label: "Chat" },
];

export type DeliveryModeValue = "in_person" | "video" | "call" | "chat";

export const DELIVERY_MODE_PACK_FIELDS: {
  value: DeliveryModeValue;
  label: string;
  enabledKey: string;
  pack: { three: string; five: string; ten: string };
}[] = [
    {
      value: "in_person",
      label: "In-person",
      enabledKey: "is_in_person_enabled",
      pack: {
        three: "in_person_three_session",
        five: "in_person_five_session",
        ten: "in_person_ten_session",
      },
    },
    {
      value: "video",
      label: "Video",
      enabledKey: "is_video_enabled",
      pack: {
        three: "three_session",
        five: "five_session",
        ten: "ten_session",
      },
    },
    {
      value: "call",
      label: "Call",
      enabledKey: "is_call_enabled",
      pack: {
        three: "call_three_session",
        five: "call_five_session",
        ten: "call_ten_session",
      },
    },
    {
      value: "chat",
      label: "Chat",
      enabledKey: "is_chat_enabled",
      pack: {
        three: "chat_three_session",
        five: "chat_five_session",
        ten: "chat_ten_session",
      },
    },
  ];

const emptyModeMap = () => ({
  in_person: "",
  call: "",
  video: "",
  chat: "",
});

const emptyPackMap = () => ({
  three_session: "",
  five_session: "",
  ten_session: "",
});

export const emptySubscriptionByMode = () => ({
  in_person: emptyPackMap(),
  video: emptyPackMap(),
  call: emptyPackMap(),
  chat: emptyPackMap(),
});

const mergePackMap = (existing: any = {}, fallback: any = {}) => ({
  three_session: existing?.three_session || fallback?.three_session || "",
  five_session: existing?.five_session || fallback?.five_session || "",
  ten_session: existing?.ten_session || fallback?.ten_session || "",
});

const mergeSubscriptionByMode = (existing: any = {}, fallback: any = {}) => {
  const result = emptySubscriptionByMode();
  (["in_person", "video", "call", "chat"] as const).forEach((mode) => {
    result[mode] = mergePackMap(existing?.[mode], fallback?.[mode]);
  });
  return result;
};

export const emptyAudienceEntry = (audience: string) => {
  const defaultDuration =
    audience === "personal"
      ? { in_person: "45", call: "45", video: "45", chat: "30" }
      : {
        in_person: DEFAULT_AUDIENCE_DURATIONS[audience] || "90",
        call: DEFAULT_AUDIENCE_DURATIONS[audience] || "90",
        video: DEFAULT_AUDIENCE_DURATIONS[audience] || "90",
        chat: DEFAULT_AUDIENCE_DURATIONS[audience] || "90",
      };
  return {
    session_price: emptyModeMap(),
    duration: defaultDuration,
    subscription_price: emptySubscriptionByMode(),
  };
};

export const ensureAudienceSessionConfig = (
  existing: any = {},
  legacyPrice: any = {},
  legacyDuration: any = {},
  legacyPacks: any = {}
) => {
  const personalExisting = existing?.personal || {};
  const hasPersonalPrice = ["in_person", "call", "video", "chat"].some(
    (m) => personalExisting?.session_price?.[m]
  );
  const hasPersonalDuration = ["in_person", "call", "video", "chat"].some(
    (m) => personalExisting?.duration?.[m]
  );
  const fallbackPacks = mergeSubscriptionByMode(
    {},
    {
      in_person: legacyPacks?.in_person || {},
      video: legacyPacks?.video || {},
      call: legacyPacks?.call || {},
      chat: legacyPacks?.chat || {},
    }
  );

  return {
    personal: {
      session_price: {
        ...emptyModeMap(),
        ...(hasPersonalPrice ? personalExisting.session_price : legacyPrice),
      },
      duration: {
        ...emptyAudienceEntry("personal").duration,
        ...(hasPersonalDuration ? personalExisting.duration : legacyDuration),
      },
      subscription_price: mergeSubscriptionByMode(
        personalExisting.subscription_price,
        fallbackPacks
      ),
    },
    couple: {
      session_price: {
        ...emptyModeMap(),
        ...(existing?.couple?.session_price || {}),
      },
      duration: {
        ...emptyAudienceEntry("couple").duration,
        ...(existing?.couple?.duration || {}),
      },
      subscription_price: mergeSubscriptionByMode(
        existing?.couple?.subscription_price,
        emptySubscriptionByMode()
      ),
    },
    family: {
      session_price: {
        ...emptyModeMap(),
        ...(existing?.family?.session_price || {}),
      },
      duration: {
        ...emptyAudienceEntry("family").duration,
        ...(existing?.family?.duration || {}),
      },
      subscription_price: mergeSubscriptionByMode(
        existing?.family?.subscription_price,
        emptySubscriptionByMode()
      ),
    },
  };
};

export const syncLegacyFromAudienceConfig = (
  audienceConfig: any,
  types: string[] = []
) => {
  const typeSet = new Set((types || []).map((t) => String(t).toLowerCase()));
  let defaultType = "personal";
  if (typeSet.has("personal") || typeSet.has("individual")) {
    defaultType = "personal";
  } else if (typeSet.has("couple") && !typeSet.has("family")) {
    defaultType = "couple";
  } else if (typeSet.has("family") && !typeSet.has("couple")) {
    defaultType = "family";
  } else if (typeSet.has("couple")) {
    defaultType = "couple";
  }
  const entry = audienceConfig?.[defaultType] || audienceConfig?.personal || {};
  const packs = mergeSubscriptionByMode(
    entry.subscription_price,
    emptySubscriptionByMode()
  );
  return {
    session_price: { ...emptyModeMap(), ...(entry.session_price || {}) },
    duration: { ...emptyModeMap(), ...(entry.duration || {}) },
    session_duration:
      entry?.duration?.video ||
      entry?.duration?.call ||
      entry?.duration?.in_person ||
      DEFAULT_AUDIENCE_DURATIONS[defaultType] ||
      "45",
    three_session: packs.video.three_session,
    five_session: packs.video.five_session,
    ten_session: packs.video.ten_session,
    in_person_three_session: packs.in_person.three_session,
    in_person_five_session: packs.in_person.five_session,
    in_person_ten_session: packs.in_person.ten_session,
    call_three_session: packs.call.three_session,
    call_five_session: packs.call.five_session,
    call_ten_session: packs.call.ten_session,
    chat_three_session: packs.chat.three_session,
    chat_five_session: packs.chat.five_session,
    chat_ten_session: packs.chat.ten_session,
  };
};

export const validateAudienceSessionPricing = (
  audienceConfig: any
): string | null => {
  for (const audience of AUDIENCE_TYPE_OPTIONS) {
    const entry = audienceConfig?.[audience.value];
    if (!entry) continue;
    for (const mode of DELIVERY_MODE_PACK_FIELDS) {
      const pack = entry.subscription_price?.[mode.value] || {};
      const hasAnyPackPrice = Boolean(
        pack.three_session || pack.five_session || pack.ten_session
      );
      const hasSinglePrice = Boolean(entry.session_price?.[mode.value]);
      if (hasAnyPackPrice && !hasSinglePrice) {
        return `${audience.label} - ${mode.label}: 1 Session Price is mandatory when a 3, 5, or 10 Session Price is filled.`;
      }
    }
  }
  return null;
};

export const getDurationForSessionType = (
  sessionType: string,
  bookingType?: string
) => {
  const audience = (sessionType || "personal").toLowerCase();
  if (audience === "couple" || audience === "family") {
    return DEFAULT_AUDIENCE_DURATIONS[audience] || "90";
  }
  return bookingType === "chat" ? "30" : "45";
};

export const transformExpertDetails = (data: any) => {
  return {
    programs: data.programs,
    is_programme_expert: data.is_programme_expert,
    first_name: data.first_name,
    full_name: data.full_name,
    is_hidden: data.is_hidden,
    spotlight: data.spotlight,
    allow_app_registration: data.allow_app_registration,
    meet_link: data.meet_link,
    session_head_start_count: data.session_head_start_count,
    age: data.age,
    about: data.about,
    date_of_birth: data.date_of_birth || "",
    holds_professional_license:
      data.holds_professional_license === true ||
      data.holds_professional_license === "true",
    professional_license_details: data.professional_license_details || "",
    outside_work: data.outside_work || "",
    profession: data.profession || "",
    top_expertise: data.top_expertise || [],
    all_expertise: data.all_expertise || [],
    profile_gender: data.profile_gender || "",
    highest_education: data.highest_education || "",
    professional_certifications: data.professional_certifications || [],
    practicing_experience_years: data.practicing_experience_years || "",
    languages_known: data.languages_known || [],
    profile_introduction: data.profile_introduction || "",
    why_therapist: data.why_therapist || "",
    therapy_approach: data.therapy_approach || "",
    phone_number: data.phone_number,
    whatsapp_phone_number: data.whatsapp_phone_number,
    country_code:data.country_code,
    personal_email_id: data.personal_email_id,
    manoshala_email_id: data.manoshala_email_id,
    address: data.address,
    longitude: data.longitude,
    latitude: data.latitude,
    session_duration: data.app_info.session_duration,
    default_session_price: data.app_info.default_session_price,
    discounted_price: data.app_info.discounted_price,
    session_price: data.app_info.session_price,
    duration: data.app_info.duration,
    audience_session_config: ensureAudienceSessionConfig(
      data.app_info.audience_session_config,
      data.app_info.session_price,
      data.app_info.duration,
      {
        in_person: data.app_info.in_person_subscription_price,
        video: data.app_info.subscription_price,
        call: data.app_info.call_subscription_price,
        chat: data.app_info.chat_subscription_price,
      }
    ),
    is_in_person_enabled: data.app_info.is_in_person_enabled,
    is_call_enabled: data.app_info.is_call_enabled,
    is_video_enabled: data.app_info.is_video_enabled,
    is_chat_enabled: data.app_info.is_chat_enabled,
    three_session: data.app_info.subscription_price.three_session || "",
    five_session: data.app_info.subscription_price.five_session,
    ten_session: data.app_info.subscription_price.ten_session,
    chat_three_session:
      data.app_info.chat_subscription_price.three_session || "",
    chat_five_session: data.app_info.chat_subscription_price.five_session,
    chat_ten_session: data.app_info.chat_subscription_price.ten_session,
    in_person_three_session:
      data.app_info.in_person_subscription_price.three_session || "",
    in_person_five_session:
      data.app_info.in_person_subscription_price.five_session,
    in_person_ten_session:
      data.app_info.in_person_subscription_price.ten_session,
    call_three_session:
      data.app_info.call_subscription_price.three_session || "",
    call_five_session: data.app_info.call_subscription_price.five_session,
    call_ten_session: data.app_info.call_subscription_price.ten_session,
    session_delivery_mode: data.app_info.session_delivery_mode,
    tags: data.app_info.tags,
    type: data.app_info.type,
    specialization: data.pdf_data.specialization,
    description: data.pdf_data.description,
    total_experience: data.pdf_data.work_experience.total_experience,
    experience_points: data.pdf_data.work_experience.experience_points,
    education: data.pdf_data.education,
    area_of_expertise: data.pdf_data.area_of_expertise,
    lead_symptoms: data.automatic_mapping.lead_symptoms,
    lead_budget_range: data.automatic_mapping.lead_budget_range,
    lead_gender: data.automatic_mapping.lead_gender,
    lead_age_range: data.automatic_mapping.lead_age_range,
    lead_language: data.automatic_mapping.lead_language,
    city: data.city,
    service_page_link: data.service_page_link,
    state: data.state,
    country: data.country,
    pin_code: data.pin_code,
    manoshala_id: data.manoshala_id,
    onboarding_documents_folder_link: data.onboarding_documents_folder_link,
    contract_documents_folder_link: data.contract_documents_folder_link,
    photograph_link: data.photograph_link,
    lead_severity: data.automatic_mapping.lead_severity,
    role: data.role,
    rating: data.app_info.rating,
    title: data.app_info.message.title,
    details: data.app_info.message.details,
    voice_note_link: data.app_info.voice_note_link,
    style: data.app_info.style,
    no_of_patients: data.app_info.no_of_patients,
    gender: data.app_info.gender,
    feedback: data.app_info.feedback,
    certifications: data.app_info.certifications,
    approach_to_therapy: data.app_info.approach_to_therapy,
    first_session: data.app_info.first_session,
    timing: data.timing,
    bank_details: data.app_info.bank_details,
    leaves: data.leaves,
    messages: data.messages,
    fcm_token: data.fcm_token,
    rejected_bookings: data.rejected_bookings,
    prices: data.prices,
    is_archived: data.is_archived,
    google_info:data.google_info,
    is_unavailable:data.is_unavailable
  };
};

export const transformOnboardingExpertDetails = (
  email: any,
  questions: any
) => {
  const firstName = questions[0].answer_data[0].label;
  const leadLanguages = questions[2].answer_data[0].label;

  // console.log(questions[0].answer_data[0].label);

  const selectedExpertGenderIndex = questions[4].answer_data.findIndex(
    (item: any) => item.value === true
  );
  const expertGender = Gender[selectedExpertGenderIndex]?.value;

  const leadSymptomsLabels = [
    ...questions[7].answer_data,
    ...questions[8].answer_data,
  ]
    .filter((item: any) => item.value === true)
    .map((item: any) => item.label.toLowerCase());

  const leadSymptomsValues = Issues.filter((issue) =>
    leadSymptomsLabels.includes(issue.label.toLowerCase())
  ).map((issue) => issue.value);

  const selectedExpertRole = expertRoles.find((role) =>
    questions[13].answer_data[0].label
      .toLowerCase()
      .includes(role.label.toLowerCase())
  );
  const expertRole = selectedExpertRole?.value;

  const expertsDuration = {
    in_person: "",
    chat: "",
    call: "",
    video: "",
  };

  questions[20].answer_data.forEach((item: any) => {
    if (item.value === true) {
      const label = item.label.toLowerCase();

      if (label.includes("video")) {
        expertsDuration.video = "45";
      } else if (label.includes("audio")) {
        expertsDuration.call = "45";
      } else if (label.includes("chat")) {
        expertsDuration.chat = "30";
      } else if (label.includes("in-person")) {
        expertsDuration.in_person = "45";
      }
    }
  });

  const selectedExpertCity = Cities.find((city) =>
    questions[21].answer_data[0].label
      .toLowerCase()
      .includes(city.label.toLowerCase())
  );

  const expertCity = selectedExpertCity?.value || "";

  const expertBankDetails = {
    account_holder_name: "",
    account_number: "",
    bank_name: "",
    ifsc_code: "",
  };

  return {
    is_programme_expert: false,
    programs: [],
    first_name: questions[0].answer_data[0].label,
    full_name: questions[0].answer_data[0].label,
    is_hidden: true,
    spotlight: false,
    allow_app_registration: true,
    meet_link: "",
    session_head_start_count: "",
    age: questions[3].answer_data[0].label,
    about: questions[10].answer_data[0].label,
    date_of_birth: "",
    holds_professional_license: false,
    professional_license_details: "",
    outside_work: "",
    profession: "",
    top_expertise: [],
    all_expertise: [],
    profile_gender: "",
    highest_education: "",
    professional_certifications: [],
    practicing_experience_years: "",
    languages_known: [],
    profile_introduction: "",
    why_therapist: "",
    therapy_approach: "",
    phone_number: questions[1].answer_data[0].label,
    whatsapp_phone_number: "",
    country_code:"",
    personal_email_id: email,
    manoshala_email_id: "",
    address: "",
    longitude: "",
    latitude: "",
    specialization: "",
    description: "",
    service_page_link: "",
    total_experience: questions[14].answer_data[0].label,
    experience_points: [],
    education: [],
    area_of_expertise: [],
    lead_symptoms: leadSymptomsValues,
    lead_budget_range: "",
    lead_gender: [],
    lead_age_range: "",
    lead_language: [],
    city: expertCity,
    state: "",
    country: "",
    pin_code: "",
    manoshala_id: "",
    session_duration: "",
    default_session_price: "",
    discounted_price: "",
    session_price: {
      in_person: "",
      chat: "",
      call: "",
      video: "",
    },
    duration: expertsDuration,
    bank_details: {
      account_holder_name: "",
      account_number: "",
      bank_name: "",
      ifsc_code: "",
    },
    manthan: {
      is_supervision_active: false,
      supervision_batch_id: "",
      supervision_enrollment_no: "",
    },
    is_in_person_enabled: expertsDuration.in_person !== "",
    is_call_enabled: expertsDuration.call !== "",
    is_video_enabled: expertsDuration.video !== "",
    is_chat_enabled: expertsDuration.chat !== "",
    three_session: "",
    ten_session: "",
    five_session: "",
    chat_three_session: "",
    chat_five_session: "",
    chat_ten_session: "",
    in_person_three_session: "",
    in_person_five_session: "",
    in_person_ten_session: "",
    call_three_session: "",
    call_five_session: "",
    call_ten_session: "",
    session_delivery_mode: [],
    tags: [],
    onboarding_documents_folder_link: "",
    contract_documents_folder_link: "",
    photograph_link: questions[23].answer_data[0].label,
    lead_severity: [],
    role: expertRole,
    type: [],
    rating: "",
    title: "",
    details: "",
    voice_note_link: "",
    style: [],
    certifications: [],
    feedback: [],
    no_of_patients: questions[15].answer_data[0].label,
    gender: expertGender,
    approach_to_therapy: questions[11].answer_data[0].label,
    first_session: questions[12].answer_data[0].label,
    leaves: [],
    messages: [],
    fcm_token: "",
    rejected_bookings: [],
    prices: [],
    is_archived: false,
  };
};

const expertRoles = [
  { value: "clinical_psychologist", label: "Clinical Psychologist" },
  { value: "psychiatrist", label: "Psychiatrist" },
  { value: "counseling_psychologist", label: "Counseling Psychologist" },
  { value: "creative_art_therapist", label: "Creative Art Therapist" },
  { value: "yoga_or_meditation_expert", label: "Yoga or Meditation Expert" },
  {
    value: "associate_clinical_psychologist",
    label: "Associate Clinical Psychologist",
  },
  {
    value: "neuropsychologist",
    label: "Neuropsychologist",
  },
];

export const Cities = [
  { value: "mumbai", label: "Mumbai" },
  { value: "delhi_ncr", label: "Delhi NCR" },
  { value: "bengaluru", label: "Bengaluru" },
  { value: "kolkata", label: "Kolkata" },
  { value: "noida", label: "Noida" },
  { value: "delhi", label: "Delhi" },
  { value: "hyderabad", label: "Hyderabad" },
  { value: "coimbatore", label: "Coimbatore" },
  { value: "bangalore", label: "Bangalore" },
  { value: "ahmedabad", label: "Ahmedabad" },
  { value: "baroda", label: "Baroda" },
  { value: "madurai", label: "Madurai" },
  { value: "vijayawada", label: "Vijayawada" },
  { value: "indore", label: "Indore" },
  { value: "lucknow", label: "Lucknow" },
];

export const Issues = [
  { value: "anxiety", label: "Anxiety" },
  { value: "Crying spells", label: "Crying Spells" },
  { value: "depressed_mood", label: "Depressed Mood" },
  { value: "grief", label: "Grief" },
  { value: "feeling_low", label: "Feeling Low" },
  { value: "understand_my_issue", label: "Understand my issue" },
  { value: "overwhelming_sadness", label: "Overwhelming Sadness" },
  { value: "unable_to_enjoy_activities", label: "Unable To Enjoy Activities" },
  { value: "decreased_need_for_sleep", label: "Decreased Need For Sleep" },
  { value: "loss_of_interest", label: "Loss of interest" },
  {
    value: "difficulties_in_concentration",
    label: "Difficulties In Concentration",
  },
  { value: "increase_in_appetite", label: "Increase In Appetite" },
  { value: "decrease_in_appetite", label: "Decrease In Appetite" },
  { value: "excessive_guilt", label: "Excessive Guilt" },
  { value: "increased_irritability", label: "Increased Irritability" },
  { value: "racing_thoughts", label: "Racing thoughts" },
  { value: "impulsivity", label: "Impulsivity" },
  { value: "panic _attacks", label: "Panic Attacks" },
  { value: "unexplained_fears", label: "Unexplained Fears" },
  { value: "excessive_worrying", label: "Excessive Worrying" },
  { value: "avoidance", label: "Avoidance" },
  { value: "hallucinations", label: "Hallucinations" },
  { value: "suspiciousness", label: "Suspiciousness" },
  { value: "increased_libido", label: "Increased Libido" },
  { value: "decreased_libido", label: "Decreased Libido" },
  { value: "relationship", label: "Relationship" },
  { value: "breakup", label: "Breakup" },
  { value: "family_issues", label: "Family Issues" },
  { value: "overthinking", label: "Overthinking" },
  { value: "clinical_disorders", label: "Clinical Disorders" },
  { value: "suicidal_ideations", label: "Suicidal Ideations" },
  { value: "loneliness", label: "Loneliness" },
  { value: "procrastination", label: "Procrastination" },
  { value: "increased_need_for_sleep", label: "Increased Need For Sleep" },
  { value: "work_stress", label: "Work Stress" },
  { value: "exam_stress", label: "Exam Stress" },
  { value: "self_esteem", label: "Self Esteem" },
  { value: "trauma", label: "Trauma" },
  { value: "self_harm", label: "Self Harm" },
  { value: "addiction", label: "Addiction" },
  { value: "depression", label: "Depression" },
  { value: "student_career ", label: "  Student Career " },
  { value: "intimacy", label: "Intimacy" },
  { value: "founder_stress", label: "Founder Stress" },
  { value: "ptsd", label: "PTSD" },
  { value: "low_confidence", label: "Low Confidence" },
  { value: "mood_swings", label: "Mood Swings" },
  { value: "low_motivation", label: "Low Motivation" },
  { value: "work_life_balance", label: "Work life balance" },
  { value: "sexual_dysfunction", label: "Sexual Dysfunction" },
  //new
  { value: "personality_disorder", label: "Personality Disorder" },
  { value: "marital_discorder", label: "Marital Discorder" },
  { value: "behavioural_problems", label: "Behavioural Problems" },
  {
    value: "obsessive_compulsive_disorder",
    label: "Obsessive Compulsive Disorder (OCD)",
  },
  { value: "insomnia", label: "Insomnia" },
  { value: "anger_management", label: "Anger Management" },
  { value: "attachment_problems", label: "Attachment Problems" },
  { value: "couple_counseling", label: "Couple Counseling" },
  { value: "eating_disorder", label: "Eating Disorder" },
  { value: "existential_crisis", label: "Existential Crisis" },
  { value: "academic_stress", label: "Academic Stress" },
  { value: "time_management", label: "Time Management" },
  {
    value: "emotionally_unstable_personality_disorder",
    label: "Emotionally Unstable Personality Disorder (EUPD)",
  },
  { value: "phobias", label: "Phobias" },
  { value: "negative_thoughts", label: "Negative Thoughts" },
  { value: "mindfulness", label: "Mindfulness" },
  { value: "body_image", label: "Body Image" },
  { value: "ADHD", label: "ADHD" },
  { value: "dissociative_disorder", label: "Dissociative Disorder" },
  { value: "special_needs", label: "Special Needs" },
  { value: "career_concerns", label: "Career Concerns" },
  { value: "suicide_prevention", label: "Suicide Prevention" },
  { value: "postpartum_depression", label: "Postpartum Depression" },
  { value: "depressive_thoughts", label: "Depressive Thoughts" },
  { value: "anxious_thoughts", label: "Anxious Thoughts" },
  { value: "yoga", label: "Yoga" },
  { value: "miscarriages_and_abortions", label: "Miscarriages and Abortions" },
  { value: "issues_of_adjustment", label: "Issues of Adjustment" },
  { value: "other", label: "Others" },
];
export const Languages = [
  { value: "hindi", label: "Hindi" },
  { value: "english", label: "English" },
  { value: "kannada", label: "Kannada" },
  { value: "tamil", label: "Tamil" },
  { value: "marathi", label: "Marathi" },
  { value: "malyalam", label: "Malyalam" },
  { value: "gujarati", label: "Gujarati" },
  { value: "bengali", label: "Bengali" },
  { value: "telugu", label: "Telugu" },
  { value: "punjabi", label: "Punjabi" },
  { value: "nepali", label: "Nepali" },
  { value: "urdu", label: "Urdu" },
  { value: "other", label: "Other" },
];
export const defaultTiming = {
  mon: [],
  tue: [],
  wed: [],
  thu: [],
  fri: [],
  sat: [],
  sun: [],
};
export const daysValue: any = {
  mon: "Monday",
  tue: "Tuesday",
  wed: "Wednesday",
  thu: "Thursday",
  fri: "Friday",
  sat: "Saturday",
  sun: "Sunday",
};

export const SeverityOfSymptoms = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
];

export const Gender = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "non-binary", label: "Non binary" },
  { value: "other", label: "Other" },
];

export const Tags = [
  { value: "most_popular", label: "Most popular" },
  { value: "discounted", label: "Discounted" },
];

export const SessionDeliveryMode = [
  { value: "online", label: "Online" },
  { value: "in_person", label: "In Person" },
];

export const Type = [
  { value: "personal", label: "Personal" },
  { value: "couple", label: "Couple" },
  { value: "family", label: "Family" },
  { value: "child", label: "Child" },
  { value: "clinical_disorder", label: "Clinical Disorder" },
  { value: "career_counseling", label: "Career Counseling" },
  { value: "relationship_counseling", label: "Relationship Counseling" },
];
